/**
 * @description maps
 * @author wangfupeng
 */



export const ELEM_TO_EDITOR = new WeakMap()
